import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import Swal from 'sweetalert2';
import { URL_DOCS } from 'src/app/config/config';

declare var $: any;

@Component({
  selector: 'app-admin-sponsor-login',
  templateUrl: './admin-sponsor-login.component.html',
  styleUrls: ['./admin-sponsor-login.component.css']
})
export class AdminSponsorLoginComponent implements OnInit {

  isEdit = false;
  isLoading = false;
  URL_DOCS = URL_DOCS;

  modalActivo: 'crear' | 'editar' | null = null;

  public listCustomers = [{ id: 0, name: '' }];
  public listSponsors : any = [];

  public nuevoAuspicio : any = {};
  public anuncionSelected: any = [];

  numeros: number[] = Array.from({ length: 10 }, (_, i) => i);
  numeroSeleccionado: number | null = null;

  erroresAuspicio: { [key: string]: boolean } = {};

  public auspicioImageFile: File | null = null;
  public auspicioImagePreview: string | null = null;

  selectedCustomerId: number | null = null;
  selectedProfileType: string = 'all';
selectedTypeSponsor: number = 0;
  adsAll: any[] = [];      // acá dejas lo que viene de la API
  adsFiltered: any[] = []; // esto es lo que pintas en la tabla

  constructor(
    private customerService: CustomerService,
    private mantenedorService: MantenedorService
  ) { }

  ngOnInit(): void {
    this.getCustomers();
    this.getSponsorAds();
    this.applyFilter();
  }

  includeGlobals = true;

 applyFilter(): void {
    const customerId = Number(this.selectedCustomerId || 0);
    const selectedProfile = String(this.selectedProfileType || 'all').toLowerCase().trim();
    const selectedSponsorType = Number(this.selectedTypeSponsor || 0); // 0 = todos
 
    this.adsFiltered = this.adsAll.filter(ad => {
      // 1) Cliente / Global
      const isCustomer = customerId ? Number(ad?.b2b_id_customer) === customerId : true;
      const isGlobal = ad?.is_global === true;
 
      const passCustomerGlobal = customerId
        ? (isCustomer || (this.includeGlobals && isGlobal))
        : true;
      if (!passCustomerGlobal) return false;
 
      // 2) Profile
      const adProfile = String(ad?.profile_type || 'all').toLowerCase().trim();
      const passProfile =
        selectedProfile === 'all' ||
        adProfile === 'all' ||
        adProfile === selectedProfile;
      if (!passProfile) return false;
 
      // 3) Tipo Sponsor
      const adSponsorType = Number(ad?.tipoSponsor || 0);
      const passSponsorType =
        selectedSponsorType === 0 || adSponsorType === selectedSponsorType;
 
      return passSponsorType;
    });
  }



  async saveAuspicio(accion: 'insert' | 'update'){
    this.isLoading = true;
    

    const objeto = accion === 'insert' ? this.nuevoAuspicio : this.anuncionSelected;
    if (!this.validarCamposObligatorios(objeto)){
    this.isLoading = false;
    return;
    } 
    
    let dataSend = {};
    
    if(accion == 'update'){
      if (this.anuncionSelected.is_popup && this.anuncionSelected.is_transversal) {
        this.anuncionSelected.is_transversal = false; // o popup=false, como prefieras
      }
      dataSend = this.anuncionSelected;

    }else if(accion == 'insert'){
      if (this.nuevoAuspicio.is_popup && this.nuevoAuspicio.is_transversal) {        
        this.nuevoAuspicio.is_transversal = false; // o popup=false, como prefieras
      }
      dataSend = this.nuevoAuspicio;
    }

    this.mantenedorService.postUpdateSponsorsCustomer(dataSend, accion)
    .then((resp: any) => {
      const id = resp['id'];
      const estado = resp['status'];
      //console.log('Anuncio modificado/creado con id:', id);
      
      if (this.auspicioImageFile && id) {
        this.mantenedorService.uploadSponsorImage(id, this.auspicioImageFile)
          .then(() => {
            this.finalizarGuardado(accion, id, estado);
          })
          .catch(err => {
            console.error('Error al subir imagen:', err);
          });
      } else {
        this.finalizarGuardado(accion, id, estado);
      }
    })
    .catch(err => {
      console.error('Error al actualizar:', err);
    })
    .finally(() => {
      this.isLoading = false;
    });
  }

  validarCamposObligatorios(obj: any): boolean {
    if (!obj.title || !obj.subtitle || !obj.starts_at ) {
      Swal.fire('Faltan datos obligatorios', 'Debes completar: título, subtítulo y fecha de inicio.', 'warning');
      return false;
    }
    return true;
  }

  public onAuspicioImageSelected(event: any): void {
    const file: File | null = event?.target?.files?.length ? event.target.files[0] : null;

    this.auspicioImageFile = file;
    this.erroresAuspicio.image_file = !file;

    if (!file) {
      this.auspicioImagePreview = null;
      return;
    }

    // Preview
    const reader = new FileReader();
    reader.onload = () => this.auspicioImagePreview = String(reader.result);
    reader.readAsDataURL(file);
  }

  clearSelectedImage(): void {
    this.auspicioImageFile = null;
    this.auspicioImagePreview = null;
    this.erroresAuspicio.image_file = false;
  }

  finalizarGuardado(accion: 'insert' | 'update', id?: number, estado?: string): void {
    // ✅ Cierra el modal con jQuery

    if(accion == 'insert'){
      if(estado == 'success'){
        Swal.fire('Guardado exitoso', '', 'success');
        ($('#crearAuspicio') as any).modal('hide');

        this.getSponsorAds();
      }else if(estado == 'failed'){
        Swal.fire({
          title: 'Error',
          text: 'Ya existe un anuncio activo para pestaña informativa',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      }
    }else if(accion == 'update'){
      if(estado == 'success'){
        Swal.fire('Modificación exitosa', '', 'success');
        this.isEdit = false;
        ($('#editarAuspicio') as any).modal('hide');

        this.getSponsorAds();
        
      }else if(estado == 'failed'){
        Swal.fire({
          title: 'Error',
          text: 'Ya existe un anuncio activo para pestaña informativa',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      }
    }
  }


  async getCustomers(){
    await this.customerService.getListCustomer().then((data: any) => {
      this.listCustomers = data.datos.data;
    })
    .catch((error: any) => {console.log(error)})
    .finally(() => { this.isLoading = false; });
  }

  async getSponsorAds(){
    //console.log('(C) getSponsorAds');
    this.isLoading = true;

    await this.mantenedorService.getSponsorAds().then((data: any) => {
      //this.listSponsors = data.data;
      this.adsAll = data.data;
      this.adsFiltered = [...this.adsAll];
      this.applyFilter();
    })
    .catch((error: any) => {console.log(error)})
    .finally(() => { this.isLoading = false; });
  }

  clickSponsor(sponsor){
    this.anuncionSelected = sponsor;
    this.auspicioImagePreview = null;
    this.erroresAuspicio.image_file = false;
  }

  cancelEditSponsor(tipo){
    if(tipo == 'update'){
      this.isEdit = false;
 this.auspicioImageFile = null;
    this.auspicioImagePreview = null;
    this.erroresAuspicio.image_file = false;    
  }else if (tipo == 'insert'){
      //($('#crearAuspicio') as any).modal('hide');
    }
  }

  onTogglePopup(): void {
    // si se marcó popup, apaga transversal
    if (this.nuevoAuspicio?.is_popup) {
      this.nuevoAuspicio.is_tranversal = false;
    }
  }


  onToggleTransversal(): void {
    if (this.nuevoAuspicio?.is_tranversal) {
      // transversal apaga popup
      this.nuevoAuspicio.is_popup = false;
      // transversal fuerza global
      //this.nuevoAuspicio.is_global = true;
      // al ser global, no hay cliente
      //this.nuevoAuspicio.client_id = null;
    } else {
      // opcional: al desmarcar transversal, NO dejes global forzado
      // si quieres que vuelva a "normal":
       this.nuevoAuspicio.is_global = false;
    }
    // recorta la bajada
    const max = this.maxSubtitleLength;
    const min = this.minSubtitleLength;
    this.nuevoAuspicio.subtitle = (this.nuevoAuspicio.subtitle || '').slice(0, max);
  }


  onToggleEditPopup(): void {
    if (this.anuncionSelected?.is_popup){
      this.anuncionSelected.is_transversal = false;
    } 
  }

  onToggleEditTransversal(): void {

    if (this.anuncionSelected?.is_tranversal) {
      // transversal apaga popup
      this.anuncionSelected.is_popup = false;
      // transversal fuerza global
      //this.anuncionSelected.is_global = true;
      // al ser global, no hay cliente
      //this.anuncionSelected.client_id = null;
    } else {
      // opcional: al desmarcar transversal, NO dejes global forzado
      // si quieres que vuelva a "normal":
       this.anuncionSelected.is_global = false;
    }
    // siempre recorta la bajada al máximo actual (150 o 350)
    const max = this.maxSubtitleLength;
    const min = this.minSubtitleLength;
    this.anuncionSelected.subtitle = (this.anuncionSelected.subtitle || '').slice(0, max)
  }

  onToggleGlobalCrear(): void {
    // Si transversal está activo, global queda forzado: no hagas nada
    //if (this.nuevoAuspicio?.is_tranversal) {
    //  this.nuevoAuspicio.is_global = true;
    //  this.nuevoAuspicio.client_id = null;
    //  return;
    //}

    // Caso normal (sin transversal):
    if (this.nuevoAuspicio?.is_global) {
      this.nuevoAuspicio.client_id = null;
    }
  }


  onToggleGlobalEditar(): void {

    //if (this.anuncionSelected?.is_tranversal) {
    //  this.anuncionSelected.is_global = true;
    //  this.anuncionSelected.client_id = null;
    //  return;
    //}

    if (this.anuncionSelected?.is_global) {
      this.anuncionSelected.client_id = null; // o b2b_id_customer, según tu modelo
      // Si tu select usa b2b_id_customer:
      this.anuncionSelected.b2b_id_customer = null;
    }
  }

  get maxSubtitleLength(): number {
    const isTransversal =
      !!(this.nuevoAuspicio?.is_transversal ?? this.nuevoAuspicio?.is_tranversal) ||
      !!(this.anuncionSelected?.is_transversal ?? this.anuncionSelected?.is_tranversal);

    return isTransversal ? 315 : 90;
  }
  get minSubtitleLength(): number {
    const isTransversal =
      !!(this.nuevoAuspicio?.is_transversal ?? this.nuevoAuspicio?.is_tranversal) ||
      !!(this.anuncionSelected?.is_transversal ?? this.anuncionSelected?.is_tranversal);

    return isTransversal ? 50 : 30;
  }


}
